import React from "react";

const ListExplore = ({ courses }) => {
  return (
    <div className="container mx-auto p-2 sm:p-4">
      <div className="overflow-x-auto">
        <table className="min-w-full relative border border-gray-300">
          <thead className="sticky top-0 bg-gray-100">
            <tr className="text-left text-gray-600">
              <th className="py-2 px-2 sm:px-4 border-b text-xs sm:text-sm">Course</th>
              <th className="py-2 px-2 sm:px-4 border-b text-xs sm:text-sm hidden sm:table-cell">University Name</th>
              <th className="py-2 px-2 sm:px-4 border-b text-xs sm:text-sm hidden md:table-cell">Application Due Date</th>
              <th className="py-2 px-2 sm:px-4 border-b text-xs sm:text-sm">Actions</th>
            </tr>
          </thead>
          <tbody>
            {courses.map((course, index) => (
              <tr key={index} className="text-gray-700 hover:bg-gray-50">
                <td className="py-2 px-2 sm:px-4 border-b text-xs sm:text-sm">
                  <div className="font-medium">{course.programName}</div>
                  <div className="text-gray-500 sm:hidden">{course.universityName}</div>
                </td>
                <td className="py-2 px-2 sm:px-4 border-b text-xs sm:text-sm hidden sm:table-cell">
                  {course.universityName}
                </td>
                <td className="py-2 px-2 sm:px-4 border-b text-xs sm:text-sm hidden md:table-cell">
                  {getTwoDaysFromNow()}
                </td>
                <td className="py-2 px-2 sm:px-4 border-b">
                  <div className="flex flex-col sm:flex-row gap-2">
                    <button className="text-blue-500 hover:text-blue-700 text-xs sm:text-sm transition-colors">
                      View Program
                    </button>
                    <button className="text-blue-500 hover:text-blue-700 text-xs sm:text-sm transition-colors">
                      Download Syllabus
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ListExplore;

function getTwoDaysFromNow() {
  const today = new Date();
  const twoDaysLater = new Date(today);
  twoDaysLater.setDate(today.getDate() + 2);

  // Format the date as desired (e.g., "Jan 13, 2025")
  const options = { year: "numeric", month: "short", day: "numeric" };
  return twoDaysLater.toLocaleDateString("en-US", options);
}
